import { render, staticRenderFns } from "./PrizeWheel.vue?vue&type=template&id=ff13ded6&scoped=true"
import script from "./PrizeWheel.vue?vue&type=script&lang=js"
export * from "./PrizeWheel.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=ff13ded6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff13ded6",
  null
  
)

export default component.exports